// extracted by mini-css-extract-plugin
module.exports =  {"campaignCard":"W_SZUowrQLtIPQqd7q5E","icon":"J_xyuOm5ZC4SWFOBraTY"};